import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_circle-pound-sterling",
  "use": "icon-fa_circle-pound-sterling-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-pound-sterling-icon lucide-circle-pound-sterling\" id=\"icon-fa_circle-pound-sterling\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M10 16V9.5a1 1 0 0 1 5 0\" /><path d=\"M8 12h4\" /><path d=\"M8 16h7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_circle-pound-sterling.svg
// module id = z8X2
// module chunks = 63